'use strict';

var box = require('../../../../../../../../../../_virtual/box.cjs');
require('../../base/accentColors.cjs');
var accentColors = require('../../../../../../../../../../_virtual/accentColors.cjs');

(function (exports) {

	var accentColors$1 = accentColors.__exports;

	exports.BOX_BASE_COLORS = void 0;
	(function(BOX_BASE_COLORS) {
	    BOX_BASE_COLORS["success"] = "success";
	    BOX_BASE_COLORS["system"] = "system";
	    BOX_BASE_COLORS["highlight"] = "highlight";
	    BOX_BASE_COLORS["danger"] = "danger";
	    BOX_BASE_COLORS["warning"] = "warning";
	    BOX_BASE_COLORS["info"] = "info";
	})(exports.BOX_BASE_COLORS || (exports.BOX_BASE_COLORS = {}));
	const BOX_COLORS = {
	    ...exports.BOX_BASE_COLORS,
	    ...accentColors$1.AVIARY_ACCENTS
	};

	exports.BOX_COLORS = BOX_COLORS;
	
} (box.__exports));
//# sourceMappingURL=box.cjs.map
